module.exports = "<select class=\"weui_select\" v-model=\"selected\">\n  <option v-for=\"option in translatedOptions\" :value=\"option.value\">{{option.text}}</option>\n</select>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cell-select.vue
 ** module id = 96
 ** module chunks = 0
 **/